module.exports = __webpack_public_path__ + "img/ResultPicture.6d71039d.svg";